import type { ListingList } from "../../post/types";

export const CARD_SLUGS = ["my-brand", "listing", "captioned", "open-house", "niche", "video-showcase", "lead-gen"] as const;
export type CardSlug = (typeof CARD_SLUGS)[number];

export function parseCardSlug(raw: string | undefined | null): CardSlug | null {
    return raw && (CARD_SLUGS as readonly string[]).includes(raw) ? (raw as CardSlug) : null;
}

export function addPostPath(card?: CardSlug, campaignId?: string): string {
    if (!card) return "/add-post";
    const base = `/add-post/${card}`;
    return campaignId ? `${base}?listing=${encodeURIComponent(campaignId)}` : base;
}

/** The picker rows are campaigns, so a deep link carries the campaign id. A stale id resolves to nothing. */
export function resolveDeepLinkListing(rows: ListingList[], campaignId: string | null): ListingList | undefined {
    if (!campaignId) return undefined;
    return rows.find((r) => r.campaignId === campaignId);
}
